// services/signalRService.js
import * as signalR from "@microsoft/signalr";

const isDevelopmentEnv = process.env.NODE_ENV === "development";
// Todo move to global config
const baseURL = isDevelopmentEnv
    ? "https://localhost:44377"
    : "http://tuvanbanhang.com";

const hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(baseURL + "/hub/import-data", { skipNegotiation: true, transport: signalR.HttpTransportType.WebSockets }) // The URL to your SignalR hub
    .configureLogging(signalR.LogLevel.Debug)
    .build();

export const startConnection = async () => {
    try {
        await hubConnection.start();
        console.log("SignalR Connected!");
    } catch (err) {
        console.error("Error connecting to SignalR:", err);
    }
};

export const addMessageListener = (callback) => {
    hubConnection.on("ImportData", callback);
};

export const sendMessage = async (user, message) => {
    await hubConnection.invoke("SendMessage", user, message);
};

export const getHubMessage = (message) => {
   const info = message.split(",");
   return {
    code: info[0],
    message: info[1],
    data: info[2]
   };
}
